import React from 'react';
import { connect } from 'react-redux';
import CSFilterBox from '~/search2/components/CSFilterBox';
import Spinner from '~/components/Spinner';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
type CSFilterBoxContainerProps = {
  onFilterChange: (...args: any[]) => any;
  isBackendDown?: boolean;
  isFiltering?: boolean;
  resultCount: string;
  filters: object;
  vcPageState?: object;
};
const CSFilterBoxContainer: React.SFC<CSFilterBoxContainerProps> = props => {
  const {
    onFilterChange,
    resultCount,
    filters,
    isFiltering = false,
    isBackendDown = false,
    vcPageState: { shouldShowVeracodePage },
  } = props;
  let filterBoxes = [];
  let csFilterBoxPlaceholder = shouldShowVeracodePage
    ? 'Search the Veracode'
    : 'Search the SourceClear';
  filterBoxes.push(
    <div className="grid__item col-5-6" key="fb-query">
      <CSFilterBox
        placeholder={`${csFilterBoxPlaceholder} ${
          SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.name
        }`}
        filterField="query"
        tabIndex="1"
        isEnd={false}
        onFilterChange={onFilterChange}
        value={filters.query}
        className="pl--"
      />
    </div>
  );
  filterBoxes.push(
    <div className="grid__item col-1-6 pt-" key="fb-count">
      <div className="font--h6 color--white" id="search-result-count">
        {isFiltering && !isBackendDown && (
          <Spinner size={15} strokeWidth={4} backgroundColor="bg-color--muted-dark" />
        )}
        {!isFiltering && !isBackendDown && resultCount}
        {isBackendDown && <span> 0 results</span>}
      </div>
    </div>
  );
  return (
    <div className="grid__item grid--middle bg-color--muted-dark p- bo-rad--3">
      <div className="grid">{filterBoxes}</div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    vcPageState: state.vcPageState,
  };
}
export default connect(mapStateToProps)(CSFilterBoxContainer);
